export function createNewEvent(eventName) {
  if (typeof Event === 'function') {
    return new Event(eventName);
  }
  var event = document.createEvent('Event');
  event.initEvent(eventName, true, true);
  return event;
}
export var CreateSyntheticEvent = function (type, element) {
  return new Promise(function (resolve, reject) {
    try {
      var customDomEvent = createNewEvent(type);
      var listener = function (nativeEvent) {
        nativeEvent.stopPropagation();
        resolve(nativeEvent);
      };
      element.addEventListener(type, listener);
      element.dispatchEvent(customDomEvent);
      element.removeEventListener(type, listener);
    } catch (err) {
      reject(err);
    }
  });
};